import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { FetchParticipantModuleCertificates, FetchParticipantModuleCertificatesFailure, FetchParticipantModuleCertificatesSuccess } from 'app/library/module-certificates/actions';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import {
    DeleteModuleCertificate,
    DeleteModuleCertificateFailure,
    DeleteModuleCertificateSuccess,
    FetchModuleUsedTemplates,
    FetchModuleUsedTemplatesFailure,
    FetchModuleUsedTemplatesSuccess,
} from '../actions';
import { ModuleCertificate } from '../models/module-certificate.model';
import { ModuleCertificateState } from '../models/module-certificate.state';
@Injectable()
export class ModuleCertificateService {
    @Select(ModuleCertificateState.getEntities)
    moduleCertificates$: Observable<ModuleCertificate[]>;

    @Select(ModuleCertificateState.getEntity)
    currentFinalGrade$: Observable<ModuleCertificate>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    async fetchModuleCertificatesOfCurrentUserByModuleId(moduleId: string): Promise<boolean> {
        this._store.dispatch(new FetchParticipantModuleCertificates(moduleId));
        return this._actionHelper.race(FetchParticipantModuleCertificatesSuccess, FetchParticipantModuleCertificatesFailure).toPromise();
    }

    async fetchModuleUsedTemplatesByModuleId(moduleId: string): Promise<boolean> {
        this._store.dispatch(new FetchModuleUsedTemplates({ moduleId }));
        return this._actionHelper.race(FetchModuleUsedTemplatesSuccess, FetchModuleUsedTemplatesFailure).toPromise();
    }

    async deleteCertificate(certificateId: string): Promise<boolean> {
        this._store.dispatch(new DeleteModuleCertificate(certificateId));
        return this._actionHelper.race(DeleteModuleCertificateSuccess, DeleteModuleCertificateFailure).toPromise();
    }
}
